/* Shared `.lpv3` header + footer used across all public marketing pages
 * (landing-style). Must be rendered inside a `<div className="lpv3">` wrapper. */
import { useNavigate } from "react-router-dom";

const NAV_LINKS = [
  { label: "Advisors", path: "/advisors" },
  { label: "Resources", path: "/resources" },
  { label: "IPO FAQ's", path: "/ipo-faq" },
  { label: "Pricing", path: "/pricing" },
  { label: "About Us", path: "/about" },
  { label: "Careers", path: "/careers" },
  { label: "Reseller Program", path: "/reseller-network" },
];

export const Lpv3Header = ({ rightSlot }) => {
  const navigate = useNavigate();
  const go = (p) => navigate(p);
  return (
    <div className="hd" data-testid="lpv3-header">
      <div className="hd-inner">
        <img src="/ipolabs-logo.png" alt="IPOLabs" className="brand-logo" onClick={() => go("/")} data-testid="lpv3-logo-btn" />
        <div className="nav">
          {NAV_LINKS.map((l) => (
            <a key={l.path} onClick={() => go(l.path)} data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}>{l.label}</a>
          ))}
        </div>
        <div className="hd-cta">
          {rightSlot}
          <span className="hd-login" onClick={() => go("/login")} data-testid="lpv3-login-link">Login</span>
          <button className="btn-purple" onClick={() => go("/login")} data-testid="lpv3-get-started-btn">Get Started →</button>
        </div>
      </div>
    </div>
  );
};

export const Lpv3Footer = () => {
  const navigate = useNavigate();
  const go = (p) => navigate(p);
  return (
    <div className="ft">
      <div className="ft-grid">
        <div>
          <img src="/ipolabs-logo.png" alt="IPOLabs" className="ft-brand-logo" />
          <div className="ft-tag">India&apos;s end-to-end IPO management platform — helping founders, promoters and CFOs go public with clarity and control.</div>
          <div className="ft-tm" data-testid="footer-trademark-notice"><span className="ft-tm-brand">IPOLabs<sup className="ft-tm-sup">TM</sup></span> is a trademark of IPO Labs AI Private Limited.</div>
        </div>
        <div className="ft-col">
          <div className="ft-col-h">Platform</div>
          <a onClick={() => go("/login")}>IPO Journey</a>
          <a onClick={() => go("/login?module=matchmaker")}>Advisor Marketplace</a>
          <a onClick={() => go("/login?module=drhp")}>DRHP Workspace</a>
          <a onClick={() => go("/login?module=funding")}>Funding Desk</a>
        </div>
        <div className="ft-col">
          <div className="ft-col-h">Company</div>
          <a onClick={() => go("/about")}>About Us</a>
          <a onClick={() => go("/pricing")}>Pricing</a>
          <a onClick={() => go("/careers")}>Careers</a>
          <a onClick={() => go("/reseller-network")}>Reseller Program</a>
        </div>
        <div className="ft-col">
          <div className="ft-col-h">Get started</div>
          <a onClick={() => go("/login")}>Log in</a>
          <a onClick={() => go("/login")}>Create workspace</a>
          <a onClick={() => go("/advisor-marketplace")}>Join as advisor</a>
          <a onClick={() => go("/resources")}>Resources</a>
        </div>
        <div className="ft-col">
          <div className="ft-col-h">Legal &amp; compliance</div>
          <a onClick={() => go("/disclaimer")}>Disclaimer</a>
          <a onClick={() => go("/resources")}>Resources</a>
          <a onClick={() => go("/disclaimer")}>Privacy Policy</a>
          <a onClick={() => go("/disclaimer")}>Terms of Services</a>
        </div>
      </div>
      <div className="ft-bot">
        <span>© {new Date().getFullYear()} IPOLabs. All rights reserved.</span>
        <span>IPOLabs · India&apos;s end-to-end IPO management platform</span>
      </div>
    </div>
  );
};
